import React, { ComponentProps } from 'react'
import {
  useFormContext,
  get,
  RegisterOptions,
  Controller,
} from 'react-hook-form'
import {
  FormattableTextField,
  FormatType,
} from "@moneyforward/mfx_biz_react_components";

type Props = ComponentProps<typeof FormattableTextField> & {
  name: string
  // ComponentPropsを利用した場合、formatTypeの型が最新化されないことがあった
  // 原因がわかっていないので、再定義してみる
  formatType: FormatType
  registerOptions?: RegisterOptions
}

const InnerFormFormattableTextField = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>,
) => {
  const { control, formState } = useFormContext()
  const { errors } = formState
  const { registerOptions, ...inputProps } = props

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field }) => {
        return (
          <FormattableTextField
            {...inputProps}
            {...field}
            onChange={(e) => {
              field.onChange(e)
              inputProps.onChange && inputProps.onChange(e)
            }}
            onBlur={(e) => {
              // Blur時にunFormat処理を行うので、その値をreact-hook-formと同期させたい
              // field.onBlurにeventをpassできないので、onChangeで代用
              field.onChange(e)
              field.onBlur()
              inputProps.onBlur && inputProps.onBlur(e)
            }}
            ref={(el) => {
              field.ref(el)
              if (typeof ref === 'function') {
                ref(el)
                return
              }
              if (ref) {
                ref.current = el
              }
            }}
            isError={get(errors, props.name)}
          />
        )
      }}
      rules={registerOptions}
    />
  )
}

export const FormFormattableTextField = React.forwardRef(
  InnerFormFormattableTextField,
)
